import {
    IDatiqMap,
    IDatiqMapGeoJson,
    IDatiqMapGeoJsonFeature,
    IDatiqMapGeoJsonFeatureProperties,
    IDatiqMapGeoJsonGeometry,
    IDatiqMapLane,
    IDatiqMapLine,
    IDatiqMapMarker,
    IDatiqMapMetric,
    IDatiqMapMetricCell,
    IDatiqMapPoint,
    IDatiqMapRange,
    IDatiqMapStyleConfiguration,
} from './datiq-map.interface';

import {
    DatiqMapGeoJsonFeatureTypes,
    DatiqMapGeoJsonGeometryTypes,
    DatiqMapGeoJsonTypes,
    DatiqMapStyleType,
} from './datiq-map.enum';
import {
    DATIQ_DEFAULT_ARRAY,
    DATIQ_DEFAULT_ID,
    DATIQ_DEFAULT_STRING,
} from '@dat/datiq-core/models';

export const defaultDatiqMapMetricRange: IDatiqMapRange = {
    high: -1,
    low: -1,
};

export const emptyDatiqMapLane: IDatiqMapLane = {
    id: DATIQ_DEFAULT_ID(),
    name: DATIQ_DEFAULT_STRING,
    curved: true,
    styles: {
        strokeColor: '#0046e0',
        strokeWeight: 2,
    },
    lines: DATIQ_DEFAULT_ARRAY as IDatiqMapLine[],
};
export const emptyDatiqMapPoint: IDatiqMapPoint = {
    id: DATIQ_DEFAULT_ID(),
    name: DATIQ_DEFAULT_STRING,
    styles: {
        strokeColor: '#0046e0',
        strokeWeight: 2,
    },
    pos: { lat: -1, long: -1 },
};
export const emptyDatiqMapMarker: IDatiqMapMarker = {
    pos: { lat: -1, long: -1 },
};

export const defaultDatiqMapMetric: IDatiqMapMetric = {
    id: '',
    label: '',
    range: { ...defaultDatiqMapMetricRange },
    styles: [],
};

export const defaultDatiqMapMetricStyle: IDatiqMapMetricCell = {
    color: '',
    range: { ...defaultDatiqMapMetricRange },
    index: -1,
};

export const defaultDatiqMapStyleConfiguration: IDatiqMapStyleConfiguration = {
    clickable: true,
    fillColor: '#f5f5f5', // White No Data
    fillOpacity: 0.1,
    strokeColor: '#192129', // DAT Grey 900
    strokeWeight: 2,
    zIndex: -1,
};

export const emptyDatiqMapGeoJson: IDatiqMapGeoJson = {
    type: DatiqMapGeoJsonTypes.Unknown,
    name: '',
    features: [],
};

export const emptyDatiqMap: IDatiqMap = {
    lat: 39,
    long: -98,
    zoom: 0,
    styleType: DatiqMapStyleType.Full,
};

export const emptyDatiqMapGeoJsonFeatureProperties: IDatiqMapGeoJsonFeatureProperties =
    {
        code: DATIQ_DEFAULT_STRING,
        name: DATIQ_DEFAULT_STRING,
    };

export const emptyDatiqMapGeoJsonFeature: IDatiqMapGeoJsonFeature = {
    type: DatiqMapGeoJsonFeatureTypes.Feature,
    properties: { ...emptyDatiqMapGeoJsonFeatureProperties },
    geometry: [...DATIQ_DEFAULT_ARRAY] as any,
};

export const emptyDatiqMapGeoJsonGeometry: IDatiqMapGeoJsonGeometry = {
    type: DatiqMapGeoJsonGeometryTypes.Unknown,
    coordinates: [...DATIQ_DEFAULT_ARRAY] as any,
};

export const defaultDatiqMapDirectionsPolyline: google.maps.PolylineOptions = {
    strokeColor: '#192129',
    strokeOpacity: 1,
    strokeWeight: 2,
};
